import { InternalAnnouncementFormType } from 'components/internal-announcements/InternalAnnouncementForm';

export const createInternalAnnouncementInitialValues: Partial<InternalAnnouncementFormType> = {};
